import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionPage } from "@/features/subscriptionpage/SubscriptionPage";

export const Route = createFileRoute("/_app/subscriptions/$subscription")({ component: Page });

function Page() {
  const { subscription } = Route.useParams();
  return <SubscriptionPage id={subscription} />;
}
